import { paletteColors } from '@evaneos/b2b-ui';

import { Heat } from '../../../resources/dossier/types';

import { heatMap } from './heat-utilities';
import { HeatChip } from './HeatChip';

type HeatChipProps = {
    heatLevel: Exclude<Heat, Heat.NONE>;
    isSelected?: boolean;
    onChange?: (heat: Heat) => void;
    isRevamped?: boolean;
};

export const HeatChipClickable = ({
    heatLevel,
    isSelected,
    onChange,
    isRevamped,
}: HeatChipProps) => {
    const { accentColor } = heatMap[heatLevel];
    return (
        <HeatChip
            heatLevel={heatLevel}
            isRevamped={isRevamped}
            component={'button'}
            showLabel
            onClick={() => onChange?.(heatLevel)}
            isSelected={!!isSelected}
            sx={{
                '&:hover': {
                    backgroundColor: accentColor[isRevamped ? 300 : 500],
                    color: isRevamped ? undefined : paletteColors.neutral[0],
                },
                '&:hover .MuiSvgIcon-root': {
                    fill: paletteColors.neutral[0],
                },
                '.MuiChip-label': {},
            }}
        />
    );
};
